/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { IAGLoanPool, IAGLoanPoolInterface } from "../IAGLoanPool";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "loaner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payableAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tickNftId",
        type: "uint256",
      },
    ],
    name: "Loaned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "loaner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "backAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tickNftId",
        type: "uint256",
      },
    ],
    name: "Unloaned",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
    ],
    name: "getBackTokenAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "loan",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "loanFee",
    outputs: [
      {
        internalType: "uint16",
        name: "serviceFee",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "fee30Days",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tickId",
        type: "uint256",
      },
    ],
    name: "unloan",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

export class IAGLoanPool__factory {
  static readonly abi = _abi;
  static createInterface(): IAGLoanPoolInterface {
    return new utils.Interface(_abi) as IAGLoanPoolInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAGLoanPool {
    return new Contract(address, _abi, signerOrProvider) as IAGLoanPool;
  }
}
